import { Body, Button, Column, paddingUtil, Row } from "@gadgetinc/widgets";
import { CreditCardIcon } from "@gadgetinc/widgets/src/icons/CreditCardIcon";
import { PencilIcon } from "@gadgetinc/widgets/src/icons/PencilIcon";
import { AmexIcon } from "@gadgetinc/widgets/src/icons/brands/AmexIcon";
import { DiscoverIcon } from "@gadgetinc/widgets/src/icons/brands/DiscoverIcon";
import { MasterCardIcon } from "@gadgetinc/widgets/src/icons/brands/MasterCardIcon";
import { VisaIcon } from "@gadgetinc/widgets/src/icons/brands/VisaIcon";
import { useStyletron } from "baseui";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import type { PaymentMethod as PaymentMethodT } from "state-trees/src/Billing";

export const PaymentMethod = observer((props: { paymentMethod: PaymentMethodT }) => {
  const { paymentMethod } = props;
  const [_, $theme] = useStyletron();

  const cardIcon = useMemo(() => {
    switch (paymentMethod.brand) {
      case "visa":
        return <VisaIcon $size={32} />;
      case "mastercard":
        return <MasterCardIcon $size={32} />;
      case "amex":
        return <AmexIcon $size={32} />;
      case "discover":
        return <DiscoverIcon $size={32} />;
      default:
        return <CreditCardIcon $size={32} />;
    }
  }, [paymentMethod]);

  return (
    <Row $align="space-between">
      <Column $gap={$theme.sizing.scale0}>
        <Body>***** ***** ***** {paymentMethod.last4}</Body>
        <Body>
          {paymentMethod.expiryMonth}/{paymentMethod.expiryYear}
        </Body>
      </Column>
      <Column $style={{ alignSelf: "stretch", justifyContent: "flex-end" }}>{cardIcon}</Column>
    </Row>
  );
});

export const PaymentMethodCard = observer((props: { paymentMethod: PaymentMethodT; onAddCard: () => void | Promise<void> }) => {
  const { paymentMethod, onAddCard } = props;
  const [_, $theme] = useStyletron();

  return (
    <Column $gap={$theme.sizing.scale300}>
      <Row $align="space-between">
        <Body $style={{ fontWeight: 600 }}>Payment</Body>
        <Button
          $style={{ ...paddingUtil(0), color: $theme.colors.contentPrimary, textDecoration: "underline" }}
          kind="tertiary"
          onClick={onAddCard}
          startEnhancer={<PencilIcon />}
        ></Button>
      </Row>
      <PaymentMethod paymentMethod={paymentMethod} />
    </Column>
  );
});
